/**
 * @generated SignedSource<<6aa45aee82e4256ab2c305b2c57f0dbc>>
 * @relayHash ebcbfa6090f28c02c4342df7a4300dfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 49590845b8ac14088766a664cb90fa97664c713b920a1d0166b42c1d715638f6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "49590845b8ac14088766a664cb90fa97664c713b920a1d0166b42c1d715638f6",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
